import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import "chart.js/auto";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getUser, getUserStatus } from "../userSlice";
import { HomeTable } from "../../components/common/infonavit/home/homeTable";
import { HomeCharts } from "../../components/common/infonavit/home/homeCharts";
import { HomeNrpFilter } from "../../components/common/infonavit/home/homeNrpFilter";
import { GetCredentialsNrps } from "../../services/user/infonavit/adminCredentials";
import { CODES } from "../../consts/codes";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);
export const InfonavitHome = () => {
  const { t } = useTranslation();

  const userInfo = useSelector(getUser);
  const userStatus = useSelector(getUserStatus);

  const [nrpList, setNrpList] = useState([]);
  const [selectedNrpsAux, setSelectedNrpsAux] = useState([]);

  const selectAllItem = {
    label: t("App.infonavitRequests.filter.selectAll"),
    value: t("App.infonavitRequests.filter.selectAll"),
  };

  /**
   * Carga los NRPs
   */
  useEffect(() => {
    if (userStatus !== "succeeded") return;

    if (userInfo?.nameRole === "Infocloud Admin") {
      fetchNrps();
    } else {
      const auxNrpList = userInfo.nrps.map((nrp) => {
        return { label: nrp, value: nrp };
      });
      setNrpList(auxNrpList);

      setSelectedNrpsAux(
        auxNrpList
          .filter((opt) => opt.value !== selectAllItem.value)
          .map((opt) => opt.value)
      );
    }
  }, [userStatus]);

  /**
   * Función que consulta y settea la información de los NRPs
   */
  const fetchNrps = async () => {
    try {
      const mainUser = userInfo.mainUser;
      const {
        status,
        data: { responseStatus, response },
      } = await GetCredentialsNrps(mainUser);

      if (
        status === CODES.COD_RESPONSE_HTTP_OK &&
        responseStatus.statusCode === CODES.S_COD_RESPONSE_SUCCESS_REQUEST
      ) {
        const auxNrpList = response.map((row, index) => {
          return { label: row.nrp, value: row.nrp };
        });

        setNrpList(auxNrpList);

        setSelectedNrpsAux(
          auxNrpList
            .filter((opt) => opt.value !== selectAllItem.value)
            .map((opt) => opt.value)
        );
      } else {
        setNrpList([]);

        setSelectedNrpsAux([]);
      }
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    }
  };

  return (
    <Box
      className="box-container"
      padding={{ xs: "1.5rem", md: "3rem", lg: "4.5rem" }}
    >
      <Grid container gap="3rem">
        {/* Title */}
        <Grid item xs={12}>
          <Grid
            container
            columnGap="1rem"
            rowGap="4.5rem"
            alignItems="center"
            justifyContent={{ xs: "center", md: "space-between" }}
          >
            <Grid
              container
              item
              xs={12}
              md="auto"
              justifyContent={{ xs: "center", sm: "flex-start" }}
            >
              <label
                className="display-large__primary-one"
                style={{ textAlign: "center" }}
              >
                {t("App.infonavitDashboard.client.welcomeTitle")}
              </label>
            </Grid>

            {/* -------- NRPs -------- */}
            <Grid
              container
              item
              xs={12}
              md="auto"
              justifyContent={{ xs: "center", sm: "flex-end" }}
            >
              <HomeNrpFilter
                nrpList={nrpList}
                selectedNrpsAux={selectedNrpsAux}
                setSelectedNrpsAux={setSelectedNrpsAux}
                selectAllItem={selectAllItem}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Charts and indicators */}
        <HomeCharts nrpList={selectedNrpsAux} />

        {/* Table + table header */}
        <HomeTable nrpList={selectedNrpsAux} />
      </Grid>
    </Box>
  );
};
